export default {"src":"/_next/static/media/VE_ICON_GREY.c7035a7e.svg","height":16,"width":58,"blurWidth":0,"blurHeight":0};